import { keepPreviousData } from "@tanstack/react-query";

import { getClosingCartons } from "@/api/production-api";
import type { ClosingCartonsResponse } from "@/schemas";
import { useCancellingQuery } from "@/hooks/use-cancelling-query";

const REFETCH_INTERVAL = 15 * 1000;

export const CLOSING_REQUIRED_JOBS_QUERY_KEY = "closing-required-cartons";

export interface UseClosingRequiredCartonsProps {
	filter: string | null;
	pageNumber: number;
	pageSize: number;
}

export const useClosingRequiredCartons = ({ filter, pageNumber, pageSize }: UseClosingRequiredCartonsProps) => {
	const queryKey = [CLOSING_REQUIRED_JOBS_QUERY_KEY, pageNumber, pageSize, filter];

	const queryFn = () =>
		getClosingCartons({
			identifier: filter,
			pageNumber,
			pageSize,
			closingType: "Available",
		});

	const { data, isLoading, error, refetch } = useCancellingQuery<ClosingCartonsResponse>({
		queryKey,
		queryFn,
		placeholderData: keepPreviousData,
		refetchInterval: REFETCH_INTERVAL,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
